import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Film } from "lucide-react";
import { reveal } from "./CaseStudyBlocks";

export const NextProject = ({ next }) => (
  <Link to={`/clients/${next.slug}`} className="block bg-[#1C1C1C] group" data-testid="next-project-link">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-32">
      <motion.div {...reveal}>
        <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF5E3A]">Next Project</span>
        <div className="flex items-end justify-between gap-6 mt-4 md:mt-6">
          <h2 className="text-4xl sm:text-6xl md:text-8xl font-black tracking-tighter text-white group-hover:text-[#FF5E3A] transition-colors duration-300 leading-none">
            {next.name}
          </h2>
          <div className="w-14 h-14 md:w-20 md:h-20 shrink-0 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#FF5E3A] group-hover:border-[#FF5E3A] transition-all duration-300">
            <ArrowRight className="text-white transition-transform duration-300 group-hover:translate-x-1" size={28} />
          </div>
        </div>
        <div className="mt-10 md:mt-14 rounded-2xl md:rounded-3xl overflow-hidden aspect-[21/9] relative bg-white/5">
          {next.preview ? (
            <img src={next.preview} alt={`${next.name} preview`} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] opacity-80 group-hover:opacity-100" />
          ) : (
            <div className="ph-grid-dark w-full h-full flex items-center justify-center">
              <div className="text-center">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center mx-auto mb-4">
                  <Film size={18} className="text-[#FF5E3A]" />
                </div>
                <p className="text-xs md:text-sm font-bold uppercase tracking-[0.15em] text-white/50">Project Preview</p>
                <p className="text-[11px] md:text-sm text-white/25 mt-1 font-medium">VIDEO OR IMAGE / 2560 × 1080</p>
              </div>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  </Link>
);
